import { sensorsUrl } from "../api/endpoints";
import axios from 'axios';
import React, { useState, useEffect, useRef, useMemo } from 'react';

import Select from "react-select";
import './Menu.css';

const Menu = ({ alignment, title, transparentBackground, options, value, draggable, pin, did, tid }) => {
  const [menuValue, setMenuValue] = useState(value);
  const [cursorState, setCursorState] = useState('idle');
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [portalVars, setPortalVars] = useState({});
  const containerRef = useRef(null);

  useEffect(() => {
    const selectedItem = (options || []).find(x => String(x.value) === String(value));
    setMenuValue(selectedItem);
  }, [value, options]);

  useEffect(() => {
    if (!containerRef.current) return;
    const a = (alignment != null && String(alignment).trim() !== '') ? String(alignment) : 'left';
    containerRef.current.style.setProperty('--menu-text-align', a);
  }, [alignment]);


  const refreshPortalVars = () => {
    if (!containerRef.current || typeof window === 'undefined') return;
    const cs = window.getComputedStyle(containerRef.current);

    const keys = [
      '--mw-dropdown-bg',
      '--mw-dropdown-border',
      '--mw-option-bg',
      '--mw-option-color',
      '--mw-option-hover-bg',
      '--mw-option-hover-color',
      '--mw-option-selected-bg',
      '--mw-option-selected-color',
      '--mw-option-disabled-color',
      '--widget-value-font-size',
      '--widget-responsive-body-size',
    ];

    const next = {};
    keys.forEach((k) => {
      const v = cs.getPropertyValue(k);
      if (v != null) next[k] = String(v).trim();
    });

    setPortalVars(next);
  };

  const handleChange = (selected) => {
    setMenuValue(selected);

    if (did) {
      const body = JSON.stringify({ device: did, template: tid, data: { [pin]: selected.value.toString() } });

      axios.post(
        sensorsUrl(`control`),
        body,
        { headers: { "Content-Type": "application/json" } }
      ).then(
        res => console.log(res.data)
      ).catch(() => {
        const previousItem = (options || []).find(x => String(x.value) === String(value));
        setMenuValue(previousItem || null);
      });
    }
  };

  const effectiveDraggable = Boolean(draggable) && !isSelectOpen;

  const cursorClass = effectiveDraggable
    ? (cursorState === 'grabbing' ? 'menu-widget--grabbing' : 'menu-widget--grab')
    : 'menu-widget--auto';


  useEffect(() => {
    if (isSelectOpen) refreshPortalVars();
  }, [isSelectOpen, alignment, transparentBackground, options]);

  const menuPortalTarget = useMemo(() => {
    if (typeof document === 'undefined') return null;
    return document.body;
  }, []);

  return (
    <div
      ref={containerRef}
      className={[
        "widget-container",
        "menu-widget",
        cursorClass,
        transparentBackground ? "menu-widget--transparent" : "",
      ].filter(Boolean).join(" ")}
      onMouseDown={() => effectiveDraggable && setCursorState('grabbing')}
      onMouseUp={() => effectiveDraggable && setCursorState('grab')}
      onMouseLeave={() => effectiveDraggable && setCursorState('grab')}
      draggable={effectiveDraggable}
      onDragStart={(e) => {
        if (!effectiveDraggable) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        const id = e.target.closest('.widget')?.id;
        if (!id) return;

        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.x;
        const offsetY = e.clientY - rect.y;
        const dragData = `menu;${id};${offsetX};${offsetY};${id.startsWith('base') ? 'add' : 'move'}`;
        e.dataTransfer.setData('text/plain', dragData);
      }}
    >
      <h3 className="menu-widget__title">{title}</h3>

      <div
        className="menu-widget__selectWrap"
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
        onWheel={(e) => e.stopPropagation()}
      >
        <Select
          options={options}
          value={menuValue}
          onChange={handleChange}
          isSearchable
          placeholder="Search and select..."
          classNamePrefix="mw-select"
          className="menu-widget__select"

          menuPortalTarget={menuPortalTarget || undefined}
          menuPosition="fixed"
          menuShouldBlockScroll
          maxMenuHeight={240}

          onMenuOpen={() => {
            setIsSelectOpen(true);
            refreshPortalVars();
          }}
          onMenuClose={() => setIsSelectOpen(false)}

          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 999999,
              ...portalVars,
            }),
            menu: (base) => ({
              ...base,
              zIndex: 999999,
              ...portalVars,
              backgroundColor: 'var(--mw-dropdown-bg)',
              border: '1px solid var(--mw-dropdown-border)',
              boxShadow: 'none',
            }),
            menuList: (base) => ({
              ...base,
              ...portalVars,
              backgroundColor: 'var(--mw-dropdown-bg)',
            }),
            option: (base, state) => ({
              ...base,
              ...portalVars,
              fontSize:
                portalVars['--widget-value-font-size'] ||
                portalVars['--widget-responsive-body-size'] ||
                base.fontSize,
              backgroundColor: state.isSelected
                ? 'var(--mw-option-selected-bg)'
                : state.isFocused
                ? 'var(--mw-option-hover-bg)'
                : 'var(--mw-option-bg)',
              color: state.isDisabled
                ? 'var(--mw-option-disabled-color)'
                : state.isSelected
                ? 'var(--mw-option-selected-color)'
                : state.isFocused
                ? 'var(--mw-option-hover-color)'
                : 'var(--mw-option-color)',
            }),
          }}
        />
      </div>
    </div>
  );
};

export default Menu;
